import React, { useState } from "react";
import { GetDoc, GetWSMgr } from "../Utils/StateLib";
import { useTopic } from "@/hooks/useTopic";
import { enumObjectTypes, enumUIModes } from "@coreapp/constants";
import { enumSidebarMode } from "@/appComponents/Navigation/RightSidebar/RightSidebar";
import { useRightSidebarContext } from "@/providers/RightSidebarProvider";
import { QChartBox } from "@coreapp/CoreApp/QChartBox";
import { Globals } from "@coreapp/CoreApp/Globals";

export const useCustomChartController = () => {
  const defaultEditRecord = {
    dataObj: null,
    override: null,
    type: null,
    branchAdd: false,
    initChanges: {},
    isMultiEdit: false,
    multiDataObjs: null,
    multiOverrides: null
  };

  const [editRecord, setEditRecord] = useState({
    [enumObjectTypes.holder]: defaultEditRecord,
    [enumObjectTypes.position]: defaultEditRecord
  });
  const [showAssignmentTab, setShowAssignmentTab] = useState(false);

  const { sideBarMode } = useRightSidebarContext();

  let sidebarModeRef = React.useRef(null);
  sidebarModeRef.current = sideBarMode;

  let showAssignmentsRef: React.MutableRefObject<boolean | null> = React.useRef(null);
  showAssignmentsRef.current = showAssignmentTab;

  const assignmentContextValue = {
    theData: editRecord,
    showAssignmentTab,
    setShowAssignmentTab,
    onSaveRecordEdit: () => {}
  };

  const isCustomChart = GetDoc()?.IsCustomChart();

  // Handle canvas selection changes for position assignment
  useTopic(
    "CanvasSelectionChange",
    ({ theElement, selectIt }: { theElement: any; selectIt: boolean }) => {
      if (!isCustomChart) return;

      const wsMgr = GetWSMgr();
      const uiMode = Globals._uiConfig?.GetUIMode();

      if (!theElement || !wsMgr || uiMode !== enumUIModes.edit) {
        return;
      }

      // Handle chart box selection (handleChartSelection logic from EmployeeList)
      if (theElement instanceof QChartBox) {
        const selectedDbObj = theElement?.GetDataObj();
        if (
          sidebarModeRef?.current === enumSidebarMode.employeeList.value &&
          selectedDbObj?.InferObjectType() === enumObjectTypes.position
        ) {
          if (selectIt) {
            setShowAssignmentTab(true);
            const key: any = selectedDbObj.InferObjectClassName();

            setEditRecord(prevState => ({
              ...prevState,
              [key]: {
                dataObj: selectedDbObj
              }
            }));
          } else {
            // position deselected - close assignment tab
            setShowAssignmentTab(false);
          }
        } else if (selectIt === true) {
          //
        }
      }
    }
  );

  return {
    assignmentContextValue
  };
};
